import { Component, input, ChangeDetectionStrategy } from "@angular/core";

let nextUniqueId = 0;

@Component({
    selector: "vds-hint",
    template: "<ng-content></ng-content>",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./hint.component.css"]
})
export class VdsHintComponent {
    id = input<string>(`vds-hint-${nextUniqueId++}`);
}
